import { ButtonProps, Popconfirm } from 'antd';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

export interface SettingsTabHeaderProps {
  tabName: string;
  tabKey: string;
  switchTabs: (tabKey: string) => void;
  visible: boolean;
  handleCancel: () => void;
  currentTabKey: string;
  resetSettings: (tabKey: string) => void;
}

const SettingsTabHeader = observer(
  ({ tabName, tabKey, switchTabs, visible, handleCancel, currentTabKey, resetSettings }: SettingsTabHeaderProps) => {
    const [t] = useTranslation('geosecma-settings');

    const onConfirm = async (e: React.MouseEvent<HTMLElement, MouseEvent> | undefined) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      resetSettings(currentTabKey);
      handleCancel();
      switchTabs(tabKey);
    };

    const onCancel = (e: React.MouseEvent<HTMLElement, MouseEvent> | undefined) => {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }

      handleCancel();
    };

    const onVisibleChange = (visible: boolean) => {
      !visible && handleCancel();
    };

    const cancelButton: { 'data-testid': string } & ButtonProps = {
      'data-testid': 'cancelButton'
    };

    const okButton: { 'data-testid': string } & ButtonProps = {
      'data-testid': 'okButton'
    };

    // TODO: add option for save and continue.
    return (
      <Popconfirm
        title={t('changesWillBeLost')}
        visible={visible}
        cancelButtonProps={cancelButton}
        okButtonProps={okButton}
        onVisibleChange={onVisibleChange}
        onConfirm={onConfirm}
        onCancel={onCancel}
        okText={t('ok')}
        cancelText={t('cancel')}
        placement="bottom"
      >
        {tabName}
      </Popconfirm>
    );
  }
);

export default SettingsTabHeader;
